import { ModuleProps, CreateModuleProps } from "components";
import { Routes } from "./Routes";
import { Rights } from "./Rights";

export const Module: ModuleProps = CreateModuleProps({
    id: "PILOT_TRANSPORT_ORDERS",
    applicationRights: Rights,
    title: 'Tilbringerordrer',
    text: 'Tilbringerordrer',
    icon: 'boat',
    url: "/transport-orders",
    sequenceNo: 17620,
    routes: Routes
})
